import { Category as CoreCategory, ICategoryData } from '@df/catalog/category/category';
import { CategoryResource } from '@df/catalog/category/category.resource';
import { TLoadDependeciesParams } from '@df/catalog/model';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { NgInject } from '@df/ng/ng-inject';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NCmsCategoryHeaderBlock } from './view/header/cms-category-header-block.component';
import { NCategoryViewLayout } from './view/layout/category-view-layout.component';

declare module '@df/catalog/category/category' {
    interface ICategoryDataV3 {
        image: string;
        text_color?: string;
        mobile_image?: string;
        seo_header?: string;
        seo_description?: string;
    }
}

export class LocalCategory<T extends ICategoryData = ICategoryData> extends CoreCategory<T> {
    /**
     * Load cms block servoce
     */
    @NgInject(ICmsBlockResource)
    private iCmsBlockResource!: ICmsBlockResource;

    @NgInject(KlevuSearchService)
    private searchService?: KlevuSearchService;

    /**
     * Category page layout variant
     */
    get lpLayoutVariant(): string {
        return this.data?.id + '';
    }

    get categoryHeaderVariant(): string {
        return this.id + '';
    }

    /**
     * Extra dependencies
     */
    protected override addDependenciesToLoader(params: TLoadDependeciesParams): void {
        super.addDependenciesToLoader(params);

        if (this.verbosity > 2) {
            params.loader.add(this.searchService?.loadKlevuBanners());
            params.loader.add(
                this.iCmsBlockResource.retrieve(
                    {
                        bareUrl: NCategoryViewLayout.BLOCK_ID,
                        variant: this.lpLayoutVariant,
                        createOnError: true
                    },
                    params
                )
            );
            params.loader.add(
                this.iCmsBlockResource.retrieve(
                    {
                        bareUrl: NCmsCategoryHeaderBlock.BLOCK_ID,
                        variant: this.categoryHeaderVariant,
                        createOnError: true
                    },
                    params
                )
            );
            // Load customer before create listing to hide banners for trade
            params.loader.add(this.app.customer?.model?.load());
        }
    }
}

CategoryResource.instance = LocalCategory;
